import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class AnnouncementBulk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      flaggedList: [],
      processedFlagList: [],
      announcementTypes: [],
      cost: 0,
      startDate: "",
      endDate: "",
      announcementType: "",
      proceed: false,
      message: '',
      errors: {},
      valid: true,
    };
    this.handleAddAnnouncement = this.handleAddAnnouncement.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
     let checkedList = this.props.checkedList;
     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (checkedList) {
      
      let request = {checkedList: checkedList}
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem("individualProfileId");
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem("lawEnforcementProfileId");
    }
     request.isPaidService = sessionStorage.getItem("isPaidService");
        axios.post(API + "/asset/assetflagannouncementstatuspost", request, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const data = response.data || {};
          let list = data.processedFlagList
          let flaggedList = []
           for(let a in list)
                {
                if(list[a].proceed) 
                    {
                        flaggedList.push(list[a])
                    }
                } 

          this.setState({
            flaggedList,
            processedFlagList: list,
            announcementTypes: data.announcementTypes,
            proceed: data.proceed,
            toastColor: data.proceed?'success': 'danger',
            msg: data.message,
            cost: data.cost
          });
        })
        .catch((error) => {
          // Don't show error for dropdown loading failure, just continue
          console.log("Failed to load dropdowns:", error);
        });
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  handleChange(e) {
    const { name, value } = e.target;   
      this.setState({ [name]: value }, this.validate);
  }


  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;
    
    if (!s.startDate) {
      errors.startDate = "Start date is required";
      valid = false;
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const start = new Date(s.startDate);

      if (start < today) {
        errors.startDate = "Start date cannot be in the past";
        valid = false;
      }
    }

    if (!s.endDate) {
      errors.endDate = "End date is required";
      valid = false;
    } else {
      const start = new Date(s.startDate);
      const end = new Date(s.endDate);

      if (s.startDate && end <= start) {
        errors.endDate = "End date must be after start date";
        valid = false;
      }
    }
    if (s.flaggedList.length === 0) {
      errors.flaggedList = "No flagged items found on the list";
      valid = false;
    }
    if (!s.proceed) {
      errors.proceed = "No flagged items found on the list";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleAddAnnouncement(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {};
    request.processedFlagList = this.state.flaggedList
    request.announcementType = this.state.announcementType
    request.startDate = this.state.startDate
    request.endDate = this.state.endDate
    request.cost = this.state.cost
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem("individualProfileId");
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem("lawEnforcementProfileId");
    }

    axios
      .post(API + "/announcement/savelist", request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg:
              response.data.message ||
              "Flag details appended successfully! Law enforcement has been notified.",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Append failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Append failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleClose() {
    this.props.closeAction();
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Append Flag Details" footerContent={<></>}>
          <div className="w-full h-10 overflow-hidden flex justify-center items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Add Announcement"
        closeAction={this.handleClose}
        footerContent={
          <>
           
              <button
                type="button"
                className="btn btn-success disabled:cursor-not-allowed"
                disabled={!s.valid}
                onClick={this.handleAddAnnouncement}
              >
                Save
              </button>
           
            <button
              type="button"
              className="btn btn-success"
              onClick={this.handleClose}
            >
              Close
            </button>
          </>
        }
      >
        <div className="h-full w-full flex flex-col">
          {divMsg}
            <div className="w-full overflow-x-auto border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unique Identifier
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Message
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {s.processedFlagList.map((asset, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.categoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.subcategoryName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.uniqueIdentifier || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {asset.primaryStatus || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                         <span
          className={
            asset.proceed
              ? "alert alert-success"
              : "alert alert-danger"
          }
        >{asset.message}</span>                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.processedFlagList.length === 0 && (
                <div className="text-gray-500 text-center py-4">
                  No flagged assets found.
                </div>
              )}
            </div>
             <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text">Start Date</label>
                  <input
                    name="startDate"
                    className={`form-control ${
                      s.errors.startDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    max={s.endDate || undefined}
                    value={s.startDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">End Date</label>
                  <input
                    name="endDate"
                    className={`form-control ${
                      s.errors.endDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={s.startDate || new Date().toISOString().split("T")[0]}
                    value={s.endDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Type</label>
                  <select
                    name="announcementType"
                    className={`form-control ${
                      s.errors.announcementType ? " !border-red-500" : ""
                    }`}
                    value={s.announcementType}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.announcementTypes.map((type) => (
                      <option key={`type-${type}`} value={type}>
                        {type.replace("_", " ")}
                      </option>
                    ))}
                  </select>
                  {s.errors.type && (
                    <span className="input-group-error">{s.errors.announcementType}</span>
                  )}
                </div>
              </div>
        </div>
      </Modal>
    );
  }
}
